import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { removeImpersonateKeyFromLocalStorage } from '../impersonate/impersonate-helpers';
import { AuthenticationErrorCodes } from '../models/authentication-error-codes.enum';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private auth: AuthService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === 401 && !err.url.includes('authorise')) {
          if (
            err.error.ErrorCode == AuthenticationErrorCodes.AccessDeniedError ||
            (!window.location.href.includes('dashboard') &&
              err.error.Title ==
                'You are not authorised to perform this action')
          ) {
            window.location.href = `${window.location.origin}/#/errors/access-denied`;
          } else {
            removeImpersonateKeyFromLocalStorage();
            this.auth.logout({
              logoutParams: { returnTo: location.origin }
            });
          }
        } else {
          return throwError(err);
        }
      })
    );
  }
}
